import { useTranslation } from 'react-i18next'
import { OnboardingNotEverythingIcon } from '../../../icons/OnboardingNotEverythingIcon'

export function NotEverythingSlide() {
  const { t } = useTranslation()

  return (
    <div className="onboarding-page__slide">
      <OnboardingNotEverythingIcon />
      <div className="onboarding-page__text-container">
        <h1 className="onboarding-page__title">{t('onboarding.notEverything.title')}</h1>
        <p className="onboarding-page__description">
          {t('onboarding.notEverything.description')}
        </p>
      </div>
    </div>
  )
}